import { studentsAPI, usersAPI } from '../services/api';

/**
 * Resolve an existing SQL student id for staging review (matched id, then email lookup).
 * @returns {Promise<string|null>}
 */
export async function resolveStagingSqlStudentId({ matchedStudentId, email } = {}) {
  if (matchedStudentId) return String(matchedStudentId);
  const lookup = String(email || '').trim();
  if (!lookup) return null;

  try {
    const byEmail = await studentsAPI.getByEmail(lookup);
    const id = byEmail.data?.id || byEmail.data?._id || null;
    if (id) return String(id);
  } catch {
    /* try users API — same path as Edit User */
  }

  try {
    const userRes = await usersAPI.getByEmail(lookup);
    const id = userRes.data?.student?.id || null;
    if (id) return String(id);
  } catch {
    /* not in SQL yet */
  }

  return null;
}
